// removed by extract-text-webpack-plugin
module.exports = {"multi":"_3cOkW9-ApdVOIwlH5MkEQx","subTitle":"HbQkfiiEl1S8wIDq2SYw-","awardBlock":"_392sZvQctJOHnULoCDkbkC","winnersBlock":"_24CY7lHtdI9PGVb1AYB4Wn","winner":"_4AfS-5ECxjQ6b9KSJuI5D","mobileBitBackground":"WP8XTAP0iKFbV0ri4qTYU","winnerBadge":"_3ts2lXVNV3fAVEVf_dBa9O","isExpand":"_3mHdL7dBHj-kyE07iMzoNh","expandBtn":"_1ZN3tzao4x8WQdILiRyaYf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AwardBlock/MultiAwardBlock.css
// module id = 171
// module chunks = 0